// Add to Cart function (same as before)
function addToCart(event, variantId) {
  event.preventDefault();
  
  const addToCartButton = event.target;
  addToCartButton.setAttribute('disabled', 'disabled');
  document.dispatchEvent(new CustomEvent('theme:loading:start'));

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify({
      id: variantId,
      quantity: 1
    })
  })
  .then(response => {
    document.dispatchEvent(new CustomEvent('theme:loading:end'));
    addToCartButton.removeAttribute('disabled');

    if (response.ok) {
      document.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: {
          variant: variantId,
          quantity: 1
        }
      }));
    } else {
      return response.json();
    }
  })
  .then(data => {
    if (data && data.description) {
      const errorMessageElement = document.createElement('span');
      errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
      errorMessageElement.innerHTML = data['description'];
      addToCartButton.insertAdjacentElement('afterend', errorMessageElement);
      setTimeout(() => {
        errorMessageElement.remove();
      }, 2500);
    }
  })
  .catch((error) => {
    console.error('Error:', error);
    document.dispatchEvent(new CustomEvent('theme:loading:end'));
    addToCartButton.removeAttribute('disabled');
  });
}

// Initialize - Modified to handle subscription products
document.addEventListener('DOMContentLoaded', function() {
  // Hide all subscription options
  document.querySelectorAll('.shopify-payment-button__button, .rc_container').forEach(el => {
    el.style.display = 'none';
  });

  // Create simple Add to Cart buttons for all products
  document.querySelectorAll('[data-product-handle]').forEach(productElement => {
    const productHandle = productElement.getAttribute('data-product-handle');
    const productForm = productElement.querySelector('form[action*="/cart/add"]');
    
    if (productForm && !productForm.querySelector('.simple-add-to-cart')) {
      const variantId = productForm.querySelector('[name="id"]').value;
      
      const addToCartBtn = document.createElement('button');
      addToCartBtn.className = 'add-to-cart-button simple-add-to-cart';
      addToCartBtn.textContent = 'Add to Cart';
      addToCartBtn.dataset.variantId = variantId;
      
      productForm.appendChild(addToCartBtn);
    }
  });

  // Handle click on our custom Add to Cart buttons
  document.addEventListener('click', function(e) {
    const button = e.target.closest('.add-to-cart-button');
    if (button) {
      e.preventDefault();
      const variantId = button.dataset.variantId || 
                       button.closest('form').querySelector('[name="id"]').value;
      addToCart(e, variantId);
    }
  });
});